import { render, staticRenderFns } from "./copyListDetail.vue?vue&type=template&id=61373700&scoped=true&"
import script from "./copyListDetail.vue?vue&type=script&lang=js&"
export * from "./copyListDetail.vue?vue&type=script&lang=js&"
import style0 from "./copyListDetail.vue?vue&type=style&index=0&id=61373700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61373700",
  null
  
)

export default component.exports